import React from 'react';
import classNames from 'classnames';
import { ArrowProps } from './ArrowProps';

import * as styles from './CarouselElements.module.scss';

export const NextArrow: React.VFC<ArrowProps> = ({
	onClick,
	color = 'black',
}) => {
	return (
		<div
			className={classNames(
				styles.wrapper,
				styles.next,
				'd-flex align-items-center justify-content-center',
				color === 'white' && styles.white
			)}
			onClick={onClick}
		>
			<div className={styles.arrow} />
		</div>
	);
};
export const PrevArrow: React.VFC<ArrowProps> = ({
	onClick,
	color = 'black',
}) => {
	return (
		<div
			className={classNames(
				styles.wrapper,
				styles.prev,
				'd-flex align-items-center justify-content-center',
				color === 'white' && styles.white
			)}
			onClick={onClick}
		>
			<div className={styles.arrow} />
		</div>
	);
};
